module.exports = __webpack_public_path__ + "src/assets/images/icon-setstar.svg?30afea2e5aaa34190979cbf9d6ce4549";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-setstar.svg
// module id = 572
// module chunks = 0